/**
 * Redux selectors for accessing state
 */

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from './index';

// Auth selectors
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
export const selectAuthLoading = (state: RootState) => state.auth.isLoading;
export const selectAuthError = (state: RootState) => state.auth.error;

// Onboarding selectors
export const selectOnboardingStep = (state: RootState) =>
  state.onboarding.currentStep;
export const selectOnboardingFormData = (state: RootState) =>
  state.onboarding.formData;
export const selectOnboardingLoading = (state: RootState) =>
  state.onboarding.isLoading;
export const selectOnboardingError = (state: RootState) =>
  state.onboarding.error;
export const selectOnboardingComplete = (state: RootState) =>
  state.onboarding.isComplete;

// Config selectors
export const selectSupportedCountries = (state: RootState) =>
  state.config.supportedCountries;
export const selectIsLoadingCountries = (state: RootState) =>
  state.config.isLoadingCountries;
export const selectCountriesError = (state: RootState) =>
  state.config.countriesError;
export const selectIsConfigInitialized = (state: RootState) =>
  state.config.isInitialized;

// Derived selector: Get country options formatted for Select component
export const selectCountryOptions = createSelector(
  [selectSupportedCountries],
  (countries) =>
    countries.map((country) => ({
      value: country.id.toString(),
      label: country.name,
    })),
);

// Subscription Packages selectors
export const selectSubscriptionPackages = (state: RootState) =>
  state.subscriptionPackages.packages;
export const selectIsLoadingPackages = (state: RootState) =>
  state.subscriptionPackages.isLoading;
export const selectPackagesError = (state: RootState) =>
  state.subscriptionPackages.error;
